import { Col, Row } from "reactstrap";
import prestadores from "../assets/img/icon/icon_prestadores.svg";
import { Link } from "react-router-dom";
import React from "react";

export const BeneficiosYellowCard = ({ to = "" }) => {
    return (
        <>
            <div className={"prestadores d-none uqai-001"}>
                <Row>
                    <Col md={5} className={"mb-4 mb-md-0"}>
                        <div className={"d-flex align-items-center justify-content-center justify-content-md-end"}>
                            <img src={prestadores} alt="" width={"35"} />
                            &nbsp;&nbsp;
                            <h5 className={"m-0"}>Prestadores médicos</h5>
                        </div>
                    </Col>
                    <Col
                        md={7}
                        className={
                            "d-flex flex-md-column justify-content-center align-items-center align-items-md-start"
                        }
                    >
                        <div className={"w-50"}>
                            <span>
                                {
                                    "Ingresa aquí para consultar los principales  médicos y poder ver cuáles tienen convenios o beneficios especiales bajo tus pólizas."
                                }
                            </span>
                        </div>
                        <div>
                            <Link to={to} className="btn btn-secondary my-3">
                                Acceder
                            </Link>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};
